<atx-grid-builder
  [rows]="rows"
  [columns]="columns"
  [rowHeaderConfig]="{
    rowHeaderTemplate: rowHeaderTemplate,
    rowHeaderWidth: rowHeaderWidth,
    rowSubHeaderWidth: columnWidth
  }"
  [gridCornerClass]="'heading-cell corner'"
  [columnWidth]="calculatedColumnWidth"
></atx-grid-builder>

<ng-template #rowHeaderTemplate let-row="row">
  <div class="d-flex justify-content-center align-items-center h-100">
    <atx-image
      class="img-fluid"
      [imageUrl]="row.data.image"
      [maxWidth]="maxImageWidth"
      data-e2e="row-image"
    >
    </atx-image>
  </div>
</ng-template>
